import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import getLocalStorageData from '../utlis/storageUtils';
import { BASE_API_URL } from '../constants';
import { getHeaders } from '../utlis/security';

export const audioBookByCategoryPageApi = createApi({
  reducerPath: 'audioBookByCategoryPageApi',
  baseQuery: fetchBaseQuery({ 
    baseUrl: BASE_API_URL,
    prepareHeaders: async (headers) => {
      const customHeaders = await getHeaders('audioBookByCategoryPageApi');
      for (const [key, value] of Object.entries(customHeaders)) {
        headers.set(key, value);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    fetchAudioBookByCategoryData: builder.query({
      query: (option) => ({
        url : 'https://snsapiv2.baganit.com/api/app/seriesbycategories', //'bookbycategories/update',
        method: 'POST',
        body : {
          "category_id": 1,
            "phone": "",
            "platform": "miniapp",
            "udid": "61183b9847cf0e51",
            "user_id": getLocalStorageData(),
            "version_code": 29,
            "version_name": "1.2.9"
        },
      }), 
    })
  }),
});

export const { useFetchAudioBookByCategoryDataQuery, endpoints } = audioBookByCategoryPageApi;